import { UntypedFormControl } from '@angular/forms';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class LanguageModel extends BaseModel implements Deserializable {

  // columns
  key: any;
  name: any;

  // client only
  control: UntypedFormControl = null;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

}
